import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";

export const GrowthPainPoints = () => {
  const questions = [
    "Can I afford to hire?",
    "Why does revenue look strong, but cash still feels tight?",
    "How much should I set aside for taxes?",
    "Are we actually as profitable as we should be?",
    "What should I do now to grow without creating bigger problems later?",
  ];

  return (
    <section className="py-10 md:py-14" style={{ backgroundColor: "hsl(40 30% 97%)" }}>
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          
          {/* Left column - Headline + body */}
          <div>
            <p className="text-sm md:text-base lg:text-lg uppercase tracking-wider font-extrabold mb-4" style={{ color: "hsl(350 70% 45%)" }}>
              The real problem
            </p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl text-black leading-tight mb-6">
              Your accountant gives you numbers. But you're still left figuring out growth{" "}
              <span style={{ color: "hsl(350 70% 45%)" }}>on your own.</span>
            </h2>

            <p className="text-base lg:text-lg text-black/60 leading-relaxed mb-4">
              You're trying to make smart decisions about hiring, cash flow, taxes, profitability, and what comes next.
            </p>

            <p className="text-base lg:text-lg text-black/60 leading-relaxed">
              But when the only help you get is backward-looking reports and year-end tax prep, you're left doing the hard part alone.
            </p>
          </div>

          {/* Right column - Questions + closing */}
          <div>
            <p className="text-base lg:text-lg text-black/80 font-semibold mb-5 flex items-center gap-2">
              <HelpCircle className="h-5 w-5" style={{ color: "hsl(350 70% 45%)" }} />
              You're still asking questions like:
            </p>

            <div className="space-y-3 mb-8">
              {questions.map((q, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 px-4 py-3 rounded-full"
                  style={{ background: "linear-gradient(135deg, hsl(0 0% 22%) 0%, hsl(0 0% 12%) 100%)" }}
                >
                  <span
                    className="h-2 w-2 rounded-full flex-shrink-0"
                    style={{ backgroundColor: "hsl(350 70% 45%)" }}
                  />
                  <span className="text-white text-sm lg:text-base">{q}</span>
                </div>
              ))}
            </div>

          </div>
        </div>

        <div className="text-center mt-10">
          <Link to="/consultation">
            <Button
              size="lg"
              className="text-base px-8 py-5 h-auto text-white border-0 transition-all duration-300 hover:scale-105 hover:shadow-xl"
              style={{ backgroundColor: "hsl(350 70% 45%)" }}
            >
              Book a Free Discovery Call
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
